/**
 * Swedish krona.
 */
export var SEK = {
  code: 'SEK',
  base: 10,
  exponent: 2
};